/**
 * Badge component type definitions
 * @module shared/types/badge.types
 */

/**
 * Badge variant enum for semantic styling
 */
export enum BadgeVariant {
  /**
   * Default primary badge
   */
  Default = 'default',

  /**
   * Secondary badge for less emphasis
   */
  Secondary = 'secondary',

  /**
   * Destructive/error badge
   */
  Destructive = 'destructive',

  /**
   * Outlined badge with border
   */
  Outline = 'outline',

  /**
   * Success badge (green)
   */
  Success = 'success',

  /**
   * Warning badge (amber)
   */
  Warning = 'warning',

  /**
   * Info badge (blue)
   */
  Info = 'info',
}

/**
 * Type guard to check if a value is a valid BadgeVariant
 */
export function isBadgeVariant(value: unknown): value is BadgeVariant {
  return Object.values(BadgeVariant).includes(value as BadgeVariant);
}

/**
 * Get all BadgeVariant values as an array
 */
export function getAllBadgeVariants(): readonly BadgeVariant[] {
  return Object.values(BadgeVariant);
}
